import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// Import translations
import en from "./en.json";
import de from "./de.json";
import ro from "./ro.json";
import it from "./it.json";
import bg from "./bg.json";
import sr from "./sr.json";
import gk from "./gk.json";
import mk from "./mk.json";
import hu from "./hu.json";
import hr from "./hr.json";

export const languages = ["en", "de", "ro", "it", "bg", "sr", "gk", "mk", "hu","hr"];

// Set up i18n
i18n.use(initReactI18next).init({
	resources: {
		en: { translation: en },
		de: { translation: de },
		ro: { translation: ro },
		it: { translation: it },
		bg: { translation: bg },
		sr: { translation: sr },
		gk: { translation: gk },
		mk: { translation: mk },
		hu: { translation: hu },
		hr: { translation: hr }
	},
	lng: "en",
	fallbackLng: "en",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
